import { DropdownButton } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { Component } from "react";
import React from "react";

import "./dropdownStyle.scss";

class DropdownComponent extends Component {
  render() {
    const { options, optionsNameProp, title } = this.props;

    return (
      <DropdownButton title={title} drop={"down"} className="dropdown__header">
        {options.map((option) => (
          <Dropdown.Item
            key={option[optionsNameProp]}
            onClick={() => this.props.onSelectElement(option)}
          >
            {option[optionsNameProp]}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    );
  }
}

export default DropdownComponent;
